// todo: Remove this file after refactoring client/components/amortization-calculator/ac-control-panel/ac-control-panel.tsx:33
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { get } from 'lodash';

export default [
  {
    title: {
      label: 'Principal & interest',
      viewType: 'text',
    },
    value: {
      label: '{{0}}',
      viewType: 'text',
      keys: [
        {
          type: 'currency',
          key: 'outputs.monthlyPayments.mortgage',
        },
      ],
    },
  },
  {
    title: {
      label: 'PMI',
      viewType: 'text',
    },
    value: {
      label: '{{0}}',
      viewType: 'text',
      keys: [
        {
          type: 'currency',
          getValue(data) {
            const outputs = get(
              data,
              'outputs.monthlyPayments.mortgageInsurancePayment'
            );
            const overrides = get(
              data,
              'overrides.monthlyPayments.mortgageInsurancePayment'
            );
            return overrides === undefined || overrides === ''
              ? outputs
              : overrides;
          },
        },
      ],
    },
    isVisible(data) {
      const value = get(
        data,
        'outputs.monthlyPayments.mortgageInsurancePayment'
      );
      return value > 0;
    },
  },
];
